import { render, staticRenderFns } from "./ReviewAffiliationForm.vue?vue&type=template&id=e9fea28c"
import script from "./ReviewAffiliationForm.vue?vue&type=script&lang=js"
export * from "./ReviewAffiliationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports